import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

/**
 *
 * @param Component
 * @returns Redirects to dashboard if user is logged in
 */
export const CheckUserLogin = ({ children }) => {
  const location = useLocation();
  const user = JSON.parse(useSelector((state) => state.user.user));
  const token = user?.sessionToken;
  const urlPresent = location.search.substring(
    location.search.indexOf("?") + 1
  );
  console.log("location", location);
  console.log("urlPresent", urlPresent);
  console.log("user", user);
  console.log("token", token);
  if (user && token) {
    if (!urlPresent) {
      return <Navigate to="/dashboard" state={{ path: location.pathname }} />;
    } else {
      return (
        <Navigate
          to={`/dashboard?${urlPresent}`}
          state={{ path: location.pathname }}
        />
      );
    }
  }

  return children;
};
